import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import {
    L10N_CONFIG,
    L10N_LOCALE,
    L10nConfig,
    L10nLocale,
    L10nTranslatePipe,
    L10nTranslationService
} from 'angular-l10n';

import { HttpClient } from "@angular/common/http";
import { FlexModule, MediaObserver } from "@ngbracket/ngx-layout";
import { APIConfigService } from "../../api.config.service";
import { AngularMaterial2Module } from "../../app.module.material";
import { AuthService } from "../../shared/auth.service";
import { BreadcrumbService } from "../../shared/breadcrumb/breadcrumb.service";
import { LoggerService } from "../../shared/logger.service";
import { SessionService } from "../../shared/session.service";
import { OaseDeleteDialogComponent } from "../immerdrin/oase.delete.component";
import { RestServiceImpl } from "../immerdrin/rest.service.impl";
import { RestService } from "../immerdrin/rest.service.interface";
import { Tabelle } from "../immerdrin/tabelle/tabelle";
import { KernrechtInsertEditComponent } from "./kernrecht.insertEdit.component";
import { Kernrecht } from "./kernrecht.model";

const PATH_FILE = "app/protected/kernrecht/kernrecht.component.ts";
const OBJ_LNG_NAME = 'kernrecht';
const BACKEND_PATH_PREFIX = 'recht/';

@Component({
    selector: 'oase-kernrecht',
    templateUrl: './kernrecht.component.html',
    providers: [{ provide: RestService, useExisting: RestServiceImpl }],
    standalone:true,
	imports: [AngularMaterial2Module, L10nTranslatePipe, FlexModule]

})
export class KernrechtComponent extends Tabelle<Kernrecht> {

    constructor(
        public route: ActivatedRoute,
        public router: Router,
        public breadcrumbService: BreadcrumbService,
        public snackBar: MatSnackBar,
        public authService: AuthService,
        public apiConfigService: APIConfigService, public http: HttpClient,
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		@Inject(L10N_CONFIG) private config: L10nConfig,
		public translation: L10nTranslationService,        // public dragulaService: DragulaService,
        public dialog: MatDialog,
		public media: MediaObserver,
        public changeDetectorRef: ChangeDetectorRef,
        public sessService: SessionService,
        public title: Title,
        public _logger: LoggerService) {

        super( route, router, breadcrumbService, snackBar,
            authService, http, translation, dialog, media, changeDetectorRef,
            sessService, title, _logger, apiConfigService, {
                OBJ_LNG_NAME: OBJ_LNG_NAME,
                BACKEND_PATH_PREFIX: BACKEND_PATH_PREFIX,
                ROUTE_NAME: "/kernrecht",
                PATH_FILE: PATH_FILE,
                DEFAULT_SORT_COLUMN: "sprachschluessel",
                extraDataForAdding: { }
            }
        );
        this.displayedColumns = ['sprachschluessel', 'admin'];
    }

    createNewElement() {
        return new Kernrecht();
    }

    loeschenSpalteName() {
        return "sprachschluessel";
    }

    getApiParams() {
        return "seite";
    }

    zeigeLoeschenMaske(element: any) {
        this._zeigeLoeschenMaske(element, OaseDeleteDialogComponent);
    }

    zeigeHinzufuegenMaske() {
        this._zeigeHinzufuegenMaske(KernrechtInsertEditComponent);
    }

    zeigeBearbeitenMaske(element) {
        this._zeigeBearbeitenMaske(element, KernrechtInsertEditComponent);
    }
}
